import type { FC } from 'react';
import type { ButtonProps } from '@components/Button';
import Button from '@components/Button';
import { Show, ShowFirstMatching } from '@components/Show';
import clsx from 'clsx';

import { buttonsContainerClasses } from '../classes';
import { Step } from '../types';

interface FormFooterProps extends ButtonProps {
  currentStep: Step;
  isLastStep: boolean;
  isLoading: boolean;
  onNext: () => void;
  onPrevious: () => void;
}

export const FormFooter: FC<FormFooterProps> = ({
  currentStep,
  isLastStep,
  isLoading,
  onNext,
  onPrevious,
  ...buttonProps
}) => {
  const isButtonDisabled = buttonProps.isDisabled || isLoading;

  return (
    <div className={clsx(buttonsContainerClasses)}>
      <Button className="h-9.5" kind="secondary" onClick={onPrevious}>
        {currentStep === Step.GeneralEntityData ? 'Cancel' : 'Previous'}
      </Button>
      <ShowFirstMatching>
        <Show when={isLastStep}>
          <Button {...buttonProps} isDisabled={isButtonDisabled} loading={isLoading} type="submit">
            Create
          </Button>
        </Show>
        <Show when={!isLastStep}>
          <Button {...buttonProps} onClick={onNext} type="button">
            Next
          </Button>
        </Show>
      </ShowFirstMatching>
    </div>
  );
};
